<div id="upload-image-mobile" class="h-100">

  <div class="mt-3">
    <kl-share-products [storeType]="dialogData?.data?.storeType" (selectedShareProducts)="onProductsSelection($event)"></kl-share-products>
  </div>

</div>
